(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ImageStorage', ImageStorage);

    ImageStorage.$inject = ['$resource'];

    function ImageStorage ($resource) {
        var resourceUrl =  'api/image-storages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
